import { jsx as t } from "react/jsx-runtime";
var a = function a(_ref) {
  var a = _ref.id,
    i = _ref.title,
    o = _ref.src,
    s = _ref.width,
    e = _ref.height,
    d = _ref.allow,
    l = _ref.sandbox,
    r = _ref.className,
    c = _ref.onLoad;
  return t("iframe", Object.assign({}, {
    id: a,
    title: i,
    src: o,
    width: s,
    height: e,
    allow: d,
    sandbox: l,
    className: r,
    onLoad: c
  }));
};
export { a as Iframe };